import Collector from '../Models/Scripture/Collector';
import Data from '../States/Data';
import Helper from '../Models/Helper';
import Scripture from '../Models/Scripture';

export default class Search {
	constructor(version, unique) {
		this._version = version;
		this._unique = unique;
	}

	async results(query, config) {
		const search = this.query(query);
		const requests = this.requests(search, this._unique);
		const word_verses = await this.wordVerses(search, requests, config);
		const verses = this.verses(word_verses);

		const collector = new Collector();
		const structure = await collector.collect(verses, config.expand, search);
		return structure;
	}

	query(query) {
		let search = query;
		search = search.replace(/[\{\}\,\.\[\]\(\)\"\'\”\`\‘\:\;\!\?\+]/g, '');
		search = search.trim().toLowerCase();
		search = search.split(/\s+/);
		search = search.map(Helper.normalize);
		return search;
	}

	requests(search, unique) {
		const parts = [];
		const requests = [];

		for (const word of search)
			if ((word.length >= 3) && unique.includes(word)) {
				const prefix = word.substring(0, 3);
				if (!parts.includes(prefix)) {
					parts.push(prefix);
					const request = Data.relative(`search/distribution/${prefix}`);
					requests.push(request);
				}
			}

		return requests;
	}

	async wordVerses(search, requests, config) {
		const word_verses = {};
		for (const word of search)
			word_verses[word] = [];

		const prefixes = await Promise.all(requests);
		for (let index = 0; index < prefixes.length; index++) {
			const current = prefixes[index];
			for (const prefix_word in current) {
				for (const word of search) {
					const expression = config.exact ? `^${word}$` : `^${word}`;
					const pattern = new RegExp(expression, 'i');
					if (pattern.test(prefix_word))
						word_verses[word] = word_verses[word].concat(current[prefix_word]);
				}
			}
		}

		return word_verses;
	}

	verses(word_verses) {
		let verses = [];
		let checked = [];
		for (const index in word_verses) {
			for (const verse of word_verses[index])
				if (!checked.includes(verse)) {
					let all = true;
					for (const scan in word_verses) {
						if (!word_verses[scan].includes(verse)) {
							all = false;
							break;
						}
					}

					if (all) verses.push(verse);
					checked.push(verse);
				}
		}

		verses = verses.filter((item, index) => verses.indexOf(item) == index);
		return verses;
	}
}